import { InfoCircleOutlined } from "@ant-design/icons";
import CalendarIcon from "@untitled-ui/icons-react/build/esm/Calendar";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import {
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
  Tooltip,
  Typography,
} from "antd";
import dayjs from "dayjs";
const { Text } = Typography;

const BondDetailsForm = ({
  formData,
  updateFormData,
  productOptions,
  bondTypeOptions,
  couponFrequencyOptions,
  custodianOptions,
  form,
  onFinish,
}) => {
  const handleValuesChange = (changedValues, allValues, onFinish) => {
    updateFormData(allValues);
  };

  const handleFinish = (_data) => {
    onFinish(_data);
    // console.log(_data);
  };

  const startOfYear = dayjs().startOf("year");
  const today = dayjs();

  return (
    <div className="form-section">
      <h2 style={{ margin: 0, fontSize: "24px", marginBottom: "24px" }}>
        Bond Details
      </h2>

      <Form
        form={form}
        layout="vertical"
        initialValues={formData}
        onFinish={handleFinish}
        onValuesChange={handleValuesChange}
        style={{ width: "100%" }}
      >
        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Bond Product Name
                  <Tooltip title="Select bond product name">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"productName"}
              rules={[
                {
                  required: true,
                  message: "Please select product",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Select bond product name"
                style={{ height: "44px" }}
                options={productOptions}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Text style={{ color: "#344054" }}>Deal Initiation Date</Text>
              }
              name={"initiationDate"}
              style={{
                flex: 1,
                marginBottom: 0,
              }}
              rules={[
                {
                  required: true,
                  message: "Deal initiation date is required",
                },
                {
                  validator: (_, value) => {
                    if (
                      !value ||
                      value.isAfter(startOfYear) ||
                      value.isSame(startOfYear, "day")
                    ) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        `Please select a date from ${startOfYear.format(
                          "YYYY-MM-DD"
                        )} onwards`
                      )
                    );
                  },
                },
              ]}
            >
              <DatePicker
                style={{ marginBottom: 0, width: "100%" }}
                placeholder="DD/MM/YYYY"
                suffixIcon={<CalendarIcon color="#667085" width={20} />}
                className="bond-date-picker custom-input"
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Branch Code
                  <Tooltip title="---">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"branchCode"}
            >
              <Input
                placeholder="---"
                style={{ height: "44px" }}
                className="of-bold-disable-input"
                disabled
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Initiated By
                  <Tooltip title="Initiated By">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"initiatedBy"}
            >
              <Input
                placeholder="Mathew Ola"
                style={{ height: "44px" }}
                className="of-bold-disable-input"
                disabled
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  User ID
                  <Tooltip title="User ID">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"userID"}
            >
              <Input
                placeholder="647456747"
                style={{ height: "44px" }}
                className="of-bold-disable-input"
                disabled
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Bond Type
                  <Tooltip title="The investor type">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"bondType"}
            >
              <Select
                placeholder="Select Bond Type"
                optionFilterProp="children"
                style={{ height: "44px", color: "#333" }}
                options={bondTypeOptions}
                className="read-only-select"
                disabled
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Issuer
                  <Tooltip title="Issuer">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"issuer"}
            >
              <Input
                placeholder="Issuer"
                style={{ height: "44px" }}
                className="of-bold-disable-input"
                disabled
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<Text style={{ color: "#344054" }}>Issue Date</Text>}
              name={"issueDate"}
              rules={[
                () => ({
                  validator(_, value) {
                    if (!value) {
                      return Promise.reject(
                        new Error(`Issue date is required`)
                      );
                    }
                    if (value?.isBefore(today, "day")) {
                      return Promise.reject(
                        new Error(
                          `Issue date cannot be lesser than ${today.format(
                            "YYYY-MM-DD"
                          )} (Today)`
                        )
                      );
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <DatePicker
                style={{ marginBottom: 0, width: "100%" }}
                placeholder="Select date"
                suffixIcon={<CalendarIcon color="#667085" width={20} />}
                className="bond-date-picker custom-input of-bold-disable-input"
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<Text style={{ color: "#344054" }}>Maturity Date</Text>}
              name={"maturityDate"}
            >
              <DatePicker
                disabled
                style={{ marginBottom: 0, width: "100%" }}
                placeholder="Select date"
                suffixIcon={<CalendarIcon color="#667085" width={20} />}
                className="bond-date-picker custom-input of-bold-disable-input disable-date"
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              name={"tenor"}
              label={
                <Space>
                  Tenor
                  <Tooltip title="Tenor">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
            >
              <Input
                addonAfter={<div>Years</div>}
                className="custom-input of-bold-disable-input read-only-select"
                style={{ height: "44px" }}
                placeholder="10"
                disabled
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              name={"couponRate"}
              label={
                <Space>
                  Coupon Rate
                  <Tooltip title="Coupon Rate">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              // rules={[
              //   {
              //     required: true,
              //     message: "Please enter coupon rate",
              //   },
              // ]}
            >
              <InputNumber
                className="custom-input of-bold-disable-input"
                style={{ height: 44, width: "100%" }}
                placeholder="10"
                suffix={"%"}
                disabled
              />
              {/* <Input
                addonAfter={<div>%</div>}
                className="custom-input of-bold-disable-input"
                style={{ height: "44px" }}
                placeholder="10"
                // disabled
              /> */}
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Coupon Payment Frequency
                  <Tooltip title="Select Coupon Payment Frequency">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"couponFrequency"}
            >
              <Select
                placeholder="Annual/Semi-Annual/Quarterly"
                optionFilterProp="children"
                style={{ height: "44px" }}
                options={couponFrequencyOptions}
                className="read-only-select"
                disabled
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              name={"currency"}
              label={
                <Space>
                  Currency
                  <Tooltip title="Select Currency">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
            >
              <Input
                placeholder="Currency"
                style={{ height: "44px" }}
                className="of-bold-disable-input"
                disabled
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Custodian
                  <Tooltip title="Select custodian">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="custodian"
              rules={[
                {
                  required: true,
                  message: "Please select custodian",
                },
              ]}
            >
              <Select
                options={custodianOptions}
                placeholder={"Select custodian"}
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                showSearch
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default BondDetailsForm;
